exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-right[data-v-0b85eb42] {\n  height: 100%;\n}\n.head-box[data-v-0b85eb42] {\n  overflow: hidden;\n}", ""]);

// exports
